<div class="tab-header">
    <h4>Documentation</h4>
</div>
<div class="data-area">
    <form id="documentForm" appPromptUnsubmitted>
        <table class="table table-hover table-inline-edit">
            <thead class="thead-light">
            <tr>
                <th width="200">Date</th>
                <th>Title</th>
                <th>Description</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr app-collection-row
            [titles$]="titles$"
            [coll]="newDocument"
            (collChanged)="create()"
            [addNewMode]="true">
            </tr>
            <tr app-collection-row
                [titles$]="titles$"
                [coll]="coll"
                (collChanged)="saveDocument($event)"
                (onDelete)="displayConfirmDialogue($event)"
                *ngFor="let coll of collections">
            </tr>
            </tbody>
        </table>
    </form>
</div>

<app-confirm-delete-modal-component></app-confirm-delete-modal-component>
